import { createRequestAction } from '~/Helpers/Action.helpers';
import { ZOOM_ACTIONS } from '~/Constants/Actions.constants';
import { ZOOM_URLS } from '~/Constants/Urls.constants';
import { IZoomSessionSetupUpdate } from '~/Models/DTO/Zoom.model';

export const requestZoomIntegrationApi = (data: { providerId: string }) =>
  createRequestAction({
    name: ZOOM_ACTIONS.GET_ZOOM_INTEGRATION_API,
    url: ZOOM_URLS.GET_ZOOM_INTEGRATION_API,
    method: 'POST',
    data,
  });

export const requestSendZoomSessionData = (data: IZoomSessionSetupUpdate) =>
  createRequestAction({
    name: ZOOM_ACTIONS.POST_ZOOM_SESSION_SETUP,
    url: ZOOM_URLS.ZOOM_SESSION_SETUP_BASE_API,
    method: 'PUT',
    data,
  });
